export const inspectionSelector = ({inspections}) => inspections.inspection;
export const updateLocationSuccessSelector = ({ inspections }) => inspections.updateLocationSuccessDetails;
